export const client = {
    sideDrawerEnabled: false,
};